import React, {useEffect, useState} from 'react';
import {
  Grid,
    Paper, Typography, Box, Stack, Avatar, TextField, 
  Button
} from '@mui/material';

import MessageIcon from '@mui/icons-material/Campaign';

import {useNavigate} from 'react-router-dom' 

import { useDispatch, useSelector } from 'react-redux';
import {useParams} from "react-router-dom"

//import {readNotification, denyNotification, selectNotificationById} from '../../store/notificationSlice'

import {
  
  selectRequestById, 
  denyRequest,} from '../../store/requestSlice'

import {usePlayContext} from '../../utils/PlayContext';

const PendingRequestDenyPage = () => {

  const {
    op, setOp,
     setStatus,   setAppTitle,
    errorMessage, setErrorMessage, setErrorTitle,
  }=usePlayContext()

  const {id} = useParams();
  const it = useSelector(selectRequestById(id))
  
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [subtitle, setSubTtitle]=useState('')
  const [hostRemarks, setHostRemarks]=useState('')

  const doDenyRequest= async()=>{
    setStatus('processing')
    
    let action={
      id,
      status:'REJECTED'
    }

    if (Boolean(hostRemarks)) action.hostRemarks=hostRemarks.trim()
    
    try
    {
      let xxx = await dispatch(denyRequest(action)).unwrap();
      setStatus('idle')

      navigate(-1)
    }
    catch (ex)
    {
        setStatus('error')
        setErrorMessage('Reject request error')
    }


  }

  
  useEffect(()=>{
    setErrorMessage('')
    setErrorTitle('')
    let tt = ''

    if (it.type==='Courier') tt='Courier Request'
    else  if (it.type==='Visitor') tt='Visitor Reuqest'                    
    else  tt='Request'                    
    setAppTitle(['Request', 'Reject', ''+tt])

    setSubTtitle("Reject Walk-in "+tt)

    return ()=>{
      setOp('')
      setErrorMessage('')
      setErrorTitle('')          
    }
  },[id, dispatch])

  

  
   
  return (
    <Box sx={{p:1}}>
      <Box sx={{ border:0, m:0,p:{xs:0,md:0}, display:'flex',  }}>
                  <Typography variant='h6'>
          {subtitle}
        </Typography>
        
      </Box>
      <Box sx={{ display: {xs:'block',md:'flex'}, py: 0, my:0, px:2,bgcolor: 'background.paper', }}  >

        
          <Grid  container  columns={12}  spacing={1}    sx={{m:0, p:0,}}  > 

              
              <Grid item xs={12} sx={{}}>
                <TextField 
                    sx={{mt:3}}
                
                fullWidth
                value={hostRemarks}
                id="id_remarks" label="Remarks" type="text" 
                onChange = { e=>setHostRemarks(e.target.value)}
                inputProps={{ maxLength: 100,  }}
                helperText={ "Remarks (optional)"}/>

              </Grid>

          </Grid>
          
</Box>
        
<Box sx={{mt:1,p:1,display:'flex', width:'100%', justifyContent: 'space-around', }}>

            <Button variant="outlined" 
              //variant="contained" 
              //color='error'  
              //disabled = {status==='success'}
              onClick ={ doDenyRequest }
            > Confirm</Button>

            
            <Button variant="outlined" 
              //variant="contained" 
              color='success'
              //disabled = {status==='success'}
              onClick ={ (e)=>{navigate(-1);} }
            > Cancel</Button>

        </Box>
      
      </Box>
    );
};

export default PendingRequestDenyPage;
